import { useCallback, useState, useEffect } from "react";
import {
  createGroup,
  EditGroup,
  EditGroupAcess,
  FetchSelectedGroupAPi,
  UpdateStatusGroupApi,
  viewGroupAPi,
} from "../services/groupService";
import { useNavigate } from "react-router-dom";
import { validateRequired } from "../utils/validators";
import images from "../utils/images";

export const useGroupList = (
  companyId,
  search,
  currentPage,
  perPage,
  status
) => {
  const [loading, setLoading] = useState(true);
  const [groupData, setGroupData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const fetchGroup = useCallback(async () => {
    setLoading(true);
    try {
      const response = await viewGroupAPi(
        `&company_id=${companyId}&search=${search}&page=${currentPage}&page_count=${perPage}&group_status=${status}`
      );
      setGroupData(response.get_group_chat_details);
      setTotalCount(response.page_context.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [companyId, search, currentPage, perPage, status]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchGroup();
    }, 500);
    return () => clearTimeout(timer);
  }, [fetchGroup]);

  return {
    loading,
    refresh: fetchGroup,
    groupData,
    totalCount,
  };
};

// create Group

export const useCreateGroup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [previewImage, setPreviewImage] = useState(images.group);

  const [formData, setFormData] = useState({
    group_name: "",
    group_user: [],
    group_admin: [],
    company: "",
    group_icon: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError((prev) => {
      const updatedErrors = { ...prev };
      if (validateRequired(value)) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };
  const validateStep = () => {
    const errors = {};
    const data = formData || {};
    if (!validateRequired(data.group_name || "")) {
      errors.group_name = "Group Name is required";
    }
    // if (!validateRequired(data.group_user || {})) {
    // }
    // if (!validateRequired(data.group_admin || {})) {
    //   errors.group_admin = "Group Admin is required";
    // }
    if (!validateRequired(data.company || "")) {
      errors.company = " Company is required";
    }
    if (!formData.group_user.length) {
      errors.group_user = "At least one group member is required";
    }
    setError(errors);

    return errors; // 🔥 You missed this
  };
  const handleSubmit = async () => {
    setLoading(true);
    const errors = validateStep();
    if (Object.keys(errors).length > 0) {
      setLoading(false);
      return;
    }
    try {
      await createGroup(formData);
      setFormData({
        group_name: "",
        group_user: [],
        group_admin: [],
        company: "",
        group_icon: null,
      });

      // Reset preview image
      setPreviewImage(images.group);
      navigate("/group", { replace: true });
    } catch (error) {
      setError(error.data);
    } finally {
      setLoading(false);
    }
  };
  return {
    formData,
    loading,
    handleInputChange,
    handleSubmit,
    setFormData,
    error, // Add this
    previewImage,
    setPreviewImage,
    setError, // Add this line
  };
};

//Fetch Group

export const useFetchGroupById = (id) => {
  const [loading, setLoading] = useState(true);
  const [selectedGroup, setSelectedGroup] = useState([]);

  const fetchGroup = useCallback(async () => {
    setLoading(true);
    try {
      const response = await FetchSelectedGroupAPi(`?group_id=${id}`);
      setSelectedGroup(response.selected_group_details);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchGroup();
  }, [fetchGroup]);

  return {
    loading,
    selectedGroup,
    refresh: fetchGroup,
  };
};

//Edit Group

export const useGroupEdit = (id) => {
  const [isLoading, setIsLoading] = useState(false);

  const editGroup = async (updates) => {
    setIsLoading(true);
    try {
      const response = await EditGroup(id, updates);
      return response;
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };
  return { editGroup, isLoading };
};

export const useGroupEditAction = (id) => {
  const [isLoading, setIsLoading] = useState(false);

  const editGroupAction = async (updates) => {
    setIsLoading(true);
    try {
      const response = await EditGroupAcess(id, updates);
      return response;
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };
  return { editGroupAction, isLoading };
};

//Update Group

export const useUpdateStatusGroup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateGroupStatus = async (ids, statusType) => {
    setLoading(true);
    setError(null);
    const data = {
      group_status: statusType,
      ids: ids,
    };

    try {
      await UpdateStatusGroupApi(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return { updateGroupStatus, loading, error };
};
